import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import MetisMenu from "react-metismenu";

const Nav = ({ menuItems }) => {
  // v2

  return (
    <Fragment>
      {menuItems.map(menu => {
        return (
          <Fragment key={menu.header}>
            <h5 className="app-sidebar__heading">{menu.header}</h5>
            <MetisMenu
              content={menu.content}
              activeLinkFromLocation
              className="vertical-nav-menu"
              iconNamePrefix=""
              classNameStateIcon="pe-7s-angle-down"
            />
          </Fragment>
        );
      })}
    </Fragment>
  );

}

const mapStateToProps = state => ({
  menuItems: state.UserOptions.menuItems
});

export default connect(mapStateToProps, null)(withRouter(Nav));
